import { Avatar, themeGet, Text } from '@primer/react';
import React from 'react';

var LTAvatar = function LTAvatar(_a) {
  var _b = _a.url,
    url = _b === void 0 ? "" : _b,
    _c = _a.label,
    label = _c === void 0 ? "" : _c;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
    sx: {
      boxShadow: "none",
      marginRight: themeGet("space.2")
    },
    src: url
  }), label && /*#__PURE__*/React.createElement(Text, null, label));
};

export { LTAvatar as default };
